<p-checkbox [(ngModel)]="isMainTransport" [binary]="true" />
